import { useNavigate, useSearchParams } from '@remix-run/react'
import { useEffect, useState } from 'react'
import { Card, Toast } from '../primitives'
import { useScrollToTop } from '~/hooks/useScrollToTop'
import { ChevronRight, Key, Passkey } from '~/icons'

export default function Privacy() {
  const navigate = useNavigate()
  useScrollToTop({})
  const [searchParams] = useSearchParams()
  const [showToast, setShowToast] = useState(false)

  useEffect(() => {
    const passwordChanged = searchParams.get('passwordChanged')
    if (passwordChanged === 'true') {
      setShowToast(true)
      navigate('/myaccount/privacidade', { replace: true })
    }
  }, [searchParams, navigate])

  return (
    <main className="w-full sm:mainContent">
      <Card color="primary" border>
        <h1 className="flex row-auto items-center font-medium">
          <Passkey className="fill-gray-100" />
          <span className="text-primary-black text-base ml-2">Privacidade</span>
        </h1>
        <hr />
        <Card className="cursor-pointer" color="secondary" onClick={() => navigate('alterarsenha')}>
          <div className="flex row-auto justify-between items-center">
            <div className="flex row-auto items-center">
              <Key className="fill-gray-100" />
              <p className="ml-2">Alterar Senha</p>
            </div>
            <ChevronRight className="fill-gray-60" />
          </div>
        </Card>
      </Card>
      <Toast
        altText="Senha alterada"
        content="Senha alterada com sucesso"
        isOpen={showToast}
        status="success"
        onOpenChange={setShowToast}
      />
    </main>
  )
}
